export const PRICE_CURRENCIES = ['TRY', 'USD', 'EUR', 'GBP'];

const normalizeCurrency = (currency = 'TRY') => (
  PRICE_CURRENCIES.includes(String(currency || 'TRY').toUpperCase())
    ? String(currency || 'TRY').toUpperCase()
    : 'TRY'
);

export const getOperationPricing = (operation) => {
  const estimatedVolume = Number(operation.estimatedVolume ?? operation.measuredM3 ?? 0);
  const unitPrice = Number(
    operation.unitPrice ??
    operation.pricePerM3 ??
    operation.account?.pricePerM3 ??
    0
  );
  const totalPrice = Number(
    operation.totalPrice ??
    operation.pricingAmount ??
    Number((estimatedVolume * unitPrice).toFixed(2))
  );

  return {
    estimatedVolume,
    pricingType: operation.pricingType || (operation.totalPrice != null || operation.pricingAmount != null ? 'FLAT_RATE' : 'PER_M3'),
    unitPrice,
    totalPrice,
    currency: normalizeCurrency(operation.currency || operation.priceCurrency || operation.account?.currency || 'TRY')
  };
};
